import AboutSection from '../sections/AboutSection';
import NewsletterSection from '../sections/NewsletterSection';

// Vista /nosotros. Como el sitio anterior, "Nosotros" es una página propia y no
// un tramo del scroll de la home: es lo que la gente comparte y lo que espera
// encontrar en el menú.
//
// La banda de título es navy por la misma razón que la de ArticleDetail: el
// header es fijo y transparente mientras no hay scroll, con enlaces claros. Si
// lo primero de la página fuese el beige de AboutSection, el menú quedaría
// ilegible en el primer pantallazo.
export default function NosotrosPage({ onNavigate }) {
  return (
    <div>
      {/* El header fijo mide 96px sin scroll, así que el padding superior lo
          suma: si no, el título queda debajo. */}
      <section
        className="relative w-full bg-[#0f1419] px-6 md:px-10 pb-16 md:pb-24"
        style={{ paddingTop: 'calc(clamp(48px, 8vw, 88px) + 96px)' }}
      >
        <div className="max-w-[1000px] mx-auto">
          <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-[#C9A26E] mb-6">
            Todd Empresas de Familia
          </span>
          <h1 className="font-heading text-[#f0ebe2] text-[clamp(40px,7vw,88px)] leading-[1.02] tracking-[-0.02em]">
            Nosotros
          </h1>
          <div className="w-12 h-px bg-[#C9A26E] mt-8" />
        </div>
      </section>

      <AboutSection onNavigate={onNavigate} />

      {/* El pie de la página: la misma cola que cierra la home y la vista de
          artículo —newsletter y, ya fuera de <main>, el footer de App. */}
      <NewsletterSection />
    </div>
  );
}
